// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__EigWT","modal":"Modal_modal__jqblM","slide-down":"Modal_slide-down__B75Sv"};